module.exports = __webpack_public_path__ + "static/img/6.fb7b3cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/6.png
// module id = hLep
// module chunks = 0